import { UserMenu } from './components/UserMenu/UserMenu';
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { LogoXBR } from "../../components/svgComponents/LogoXBR";
import useFooterModal from "../../hooks/useFooterModal";
import { saveLocation } from "../../redux/locations/redirectSlice";
import { selectThemeMode, setThemeMode } from "../../redux/theme/themeSlice";
import FooterModal from "../FooterModal/FooterModal";
import NodesSvg from "../svgComponents/NodesSvg";
import PoolSvg from "../svgComponents/PoolSvg";
import SwapSvg from "../svgComponents/SwapSvg";
import BurgerMenu from "./components/BurgerMenu";
import BurgerMenuButton from "./components/BurgerMenuButton";
import NavigationLink from "./components/NavigationLink";
import ToggleThemeButton from "./components/ToggleThemeButton";
import TokensList from "./components/TokensList";
import ArrowDropDownIcon from "../svgComponents/ArrowDropDownIcon";
import { useAppStore } from '../../store/appStore';
import { ConnectWalletButton } from './components/ConnectWalletButton/ConnectWalletButton';
import { useTokensStore } from '../../store/tokensStore';
import { useTheme } from '@mui/material';

const Header = () => {
	const {xbrPrice, setXbrPrice, tbaPrice, setTbaPrice, usdtPrice, setUsdtPrice, usdcPrice, setUsdcPrice}= useTokensStore() 
  const dispatch = useDispatch();
  const currentMode = useSelector(selectThemeMode);
	const {walletAddress, isBurgerOpened, setIsBurgerOpened, isOpenedUserMenu, setIsOpenedUserMenu}= useAppStore() 
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
	const theme = useTheme();
	const alt = theme.palette.background.alt;

		const formatBalanceForPrice = (balance) => {
			const num = parseFloat(balance);
			if (num >= 1e12) {
				return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T"; // Trillions
			} else if (num >= 1e9) {
				return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B"; // Billions
			} else if (num >= 1e6) {
				return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M"; // Millions
			} else if (num >= 1e3) {
				return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K"; // Thousands
			} else {
				return num.toFixed(4).replace(/\.00$/, ""); // Output as a string with two decimal places
			}
		};

  const tokensPrices = [
    { id: 1, tokenName: "TBA", tokenValue: tbaPrice ? formatTbaPrice(Number(tbaPrice)) : "0.0000" },
    { id: 2, tokenName: "XBR", tokenValue: xbrPrice ? formatBalanceForPrice(xbrPrice): "0.0000" },
    { id: 3, tokenName: "USDT", tokenValue: usdtPrice ?formatBalanceForPrice(usdtPrice): "0.0000" },
    { id: 4, tokenName: "USDC", tokenValue: usdcPrice ?formatBalanceForPrice(usdcPrice): "0.0000" },
  ];
	
		const headerRef = useRef(null);
		const burgerButRef = useRef(null);
	
		const openBuggerMenu = () => {
			setIsBurgerOpened(true);
			document.body.style.overflow = "hidden";
		};

		const closeHeaderModalMob = () => {
			setIsBurgerOpened(false);
			document.body.style.overflow = "";
		};
	
		const closeHeaderModal = useCallback((event) => {
			if (
				headerRef.current &&
				!burgerButRef.current.contains(event.target) &&
				!headerRef.current.contains(event.target)
			) {
				setIsBurgerOpened(false);
				document.body.style.overflow = "";
			}
		}, []);

		useEffect(() => {
			if (isBurgerOpened) {
				document.addEventListener("mousedown", closeHeaderModal);
			} else {
			}
			return () => {
				document.removeEventListener("mousedown", closeHeaderModal);
			};
		}, [isBurgerOpened, closeHeaderModal]);

  const [isDropdownOpen2, setDropdownOpen2] = useState(false);
  const [updatedMockDataToken, setUpdatedMockDataToken] = useState([]);

  const mockDataToken = [
    {
      id: 1,
      token: "XBR",
      value: 0.0,
    },
    {
      id: 2,
      token: "MATIC",
      value: 0.0,
    },
    {
      id: 3,
      token: "USDT",
      value: 0.0,
    },
  ];

  const dropdownRef = useRef(null);
  const dropdownRef2 = useRef(null);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const updateWindowSize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    const handleResize = () => {
      updateWindowSize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const isMobileDevice = windowSize.width <= 768;
    setIsMobile(isMobileDevice);
  }, [windowSize]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setDropdownOpen(false);

        setDropdownOpen2(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isDropdownOpen, isDropdownOpen2]);

  const handleModeChange = () => {
    if (currentMode === "dark") {
      document.body.classList.remove("dark");
      dispatch(setThemeMode("light"));
      return;
    }
    document.body.classList.add("dark");
    dispatch(setThemeMode("dark"));
  };

  useEffect(() => {
    updateTokenBalances();
  }, [walletAddress]);

  const tokenAddresses = [
    "0x253b1eCc08207bAA021f52e7BA4f602389fa41A5",
    "0x7e1AE068Ac4e0ffD7a84750c2FB093A0EAE9aEa2",
    "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    // Add more accounts as needed
  ];
  const updateTokenBalances = async () => {
    try {
      if (
        !walletAddress
      ) {
        setUpdatedMockDataToken(
          mockDataToken.map((token) => ({ ...token, value: 0.0 }))
        );
        return;
      }

      const URL = process.env.REACT_APP_API;
      const response = await axios.get(
        `${URL}/v1/xbr/coin-price?&address=${tokenAddresses}&count=157860000`
      );
      const { xbrPrice, maticPrice, usdtPrice } = response.data; // Assuming the API returns prices with these keys

      setUpdatedMockDataToken([
        { id: 1, token: "XBR", value: parseFloat(xbrPrice) },
        { id: 2, token: "MATIC", value: parseFloat(maticPrice) },
        { id: 3, token: "USDT", value: parseFloat(usdtPrice) },
      ]);
    } catch (error) {
      console.error("Error fetching token prices:", error);
      setUpdatedMockDataToken(
        mockDataToken.map((token) => ({ ...token, value: 0.0 }))
      );
    }
  };
  const [activeRoute, setActiveRoute] = useState("/");

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location]);

  useEffect(() => {
    if (location.pathname === "/swap") {
      dispatch(saveLocation(`swap`));
    }
  }, []);


  function formatTbaPrice(price) {
    // Ensure the price is a number
    if (typeof price !== "number" || isNaN(price)) return "NaN";

    // Convert the price to a string in fixed-point notation to ensure precision
    let priceStr = price.toFixed(25); // Use enough precision to capture all significant digits

    // Find the index of the decimal point
    let decimalIndex = priceStr.indexOf(".") + 1;

    // Find the index of the first non-zero digit after the decimal point
    let firstNonZeroIndex = decimalIndex;
    while (
      priceStr[firstNonZeroIndex] === "0" &&
      firstNonZeroIndex < priceStr.length
    ) {
      firstNonZeroIndex++;
    }

    // Count the number of leading zeroes
    let zeroCount = firstNonZeroIndex - decimalIndex;

    // Get the significant digits part (adjust the length as needed)
    let significantPart = priceStr.substring(
      firstNonZeroIndex,
      firstNonZeroIndex + 3
    );

    // Construct the formatted string
    return `0.0(${zeroCount})${significantPart}`;
  }

  const fetchPrice = async (address) => {
    const URL = `${process.env.REACT_APP_API}/v1/xbr/token-prices?address=${address}`;
    const response = await axios.get(URL);

    return response?.data?.data?.attributes?.price_usd;
  };

  const getXBRAndTBA = async () => {
    const XBR = await fetchPrice("0xD44CaEBbF5C5a3848357eC05e24220BEBEF41d40");
    const TBA = await fetchPrice("0x7e1AE068Ac4e0ffD7a84750c2FB093A0EAE9aEa2");
    setXbrPrice(XBR);
    setTbaPrice(TBA);
  };

  const getusdtusdcPrice = async () => {
    const USDT = await fetchPrice("0xc2132D05D31c914a87C6611C10748AEb04B58e8F");
    const USDC = await fetchPrice("0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359");
    setUsdtPrice(USDT);
    setUsdcPrice(USDC);
  };

  useEffect(() => {
    getXBRAndTBA();
    getusdtusdcPrice();
  }, [setXbrPrice, setTbaPrice]);

  const {
    openFooterModal,
    toggleFooterState,
    footerRef,
    onClose,
    arrowButRef,
  } = useFooterModal();

  return (
    <header
      className={
        "w-full bg-transparent relative py-[13px] mx-auto  max-w-[1440px] px-[16px] md:px-[35px]"
      }
    >
      <BurgerMenu
        toggleTheme={handleModeChange}
        tokens={tokensPrices}
        isMenuOpen={isBurgerOpened}
        headerRef={headerRef}
        closeHeaderModalMob={closeHeaderModalMob}
      />
      <div className="relative">
        <FooterModal
          isOpen={openFooterModal}
          footerRef={footerRef}
          onClose={onClose}
        />
        <div className="flex justify-between items-center">
          <div className="flex gap-[16px] z-[500] items-center relative">
            <button
              ref={arrowButRef}
              type="button"
              onClick={toggleFooterState}
              className="cursor-pointer"
            >
              <ArrowDropDownIcon fill="blue" />
            </button>

            <Link to="/">
              <LogoXBR />
            </Link>
          </div>
          <div className="hidden lg:block">
            <TokensList tokens={tokensPrices} />
          </div>

          <div className="hidden md:flex h-[45px] items-center gap-4 z-50">
            <NavigationLink
              label={"pool"}
              linkImage={<PoolSvg />}
              href={"https://pool.xbullrun.org"}
            />
            {location.pathname === "/swap" ? (
              <NavigationLink
                label={"node"}
                linkImage={<NodesSvg />}
                href={"/node"}
              />
            ) : (
              <NavigationLink
                label={"Swap"}
                linkImage={<SwapSvg />}
                href={"/swap"}
              />
            )}

						<ConnectWalletButton />

            <ToggleThemeButton toggleTheme={handleModeChange} />
            <div
              ref={dropdownRef}
              style={{ backgroundColor: alt }}
              className={`relative ${
                isMobile ? "hidden" : "hidden equal-width-dropdown"
              }`}
            />
            <div
              ref={dropdownRef2}
              style={{ backgroundColor: alt }}
              className={`relative ${
                isMobile ? "hidden" : "hidden equal-width-dropdown"
              }`}
            />
          </div>
          <div className="md:hidden flex gap-3 z-50">
					<ConnectWalletButton />
            <BurgerMenuButton
              handleClick={openBuggerMenu}
              burgerButRef={burgerButRef}
            />
          </div>
        </div>
      </div>

			<UserMenu isOpened={isOpenedUserMenu} setIsOpened={setIsOpenedUserMenu} />
    </header>
  );
};

export default Header;
